import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@common/services/ui/window.service';

@Injectable()
export class VersionService {
  constructor(@Inject(WINDOW) private readonly window: Window) {}

  public get version(): string {
    const version = this.window['fiAgentVersion'];
    if (!version) {
      console.error('Version is not set, check deploy');
      return '-1';
    }
    return version;
  }
}
